import { render, staticRenderFns } from "./CRMView.vue?vue&type=template&id=e941de1c&scoped=true"
import script from "./CRMView.vue?vue&type=script&lang=js"
export * from "./CRMView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e941de1c",
  null
  
)

export default component.exports